let mapsApiLoaded = false;

export function setupTestMap() {
    const mapContainers = document.querySelectorAll('[data-action="map-v2"]');

    if (!mapsApiLoaded && mapContainers.length > 0) {
        const mapsApi = document.createElement('script');
        mapsApi.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDJgnO4a9JHeE-67hHYY65OVPBF-E8I7p0';
        mapsApi.async = true;
        mapsApi.defer = true;
        document.body.appendChild(mapsApi);
        mapsApi.addEventListener('load', initTestMap);
    } else {
        if (mapContainers.length > 0) {
            initTestMap();
        }
    }

    function initTestMap() {
        let map;
        let bounds;

        function fitBounds() {
            map.fitBounds(bounds);
        }

        if (!mapsApiLoaded) {
            mapsApiLoaded = true;
        }

        Array.from(mapContainers).forEach(mapContainer => {
            const mapElm = document.getElementById(mapContainer.getAttribute('data-target'));

            if (mapElm) {
                const windowWidth = window.innerWidth;
                const swLat = mapContainer.getAttribute('data-sw-lat');
                const swLng = mapContainer.getAttribute('data-sw-lng');
                const neLat = mapContainer.getAttribute('data-ne-lat');
                const neLng = mapContainer.getAttribute('data-ne-lng');
                const sw = new google.maps.LatLng(swLat, swLng);
                const ne = new google.maps.LatLng(neLat, neLng);
                bounds = new google.maps.LatLngBounds(sw, ne);

                if (windowWidth >= 768) {
                    const mapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":"0"},{"weight":1.2},{"gamma":"1"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f4f3f2"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"},{"weight":"1"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f4f3f2"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#f4f3f2"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"weight":0.2},{"gamma":"1"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"gamma":"1"}]},{"featureType": "water","elementType": "labels","stylers": [{"visibility": "off"}]}];

                    map = new google.maps.Map(mapElm, {
                        mapTypeId: 'roadmap',
                        disableDefaultUI: true,
                        draggable: false,
                        scrollwheel: false,
                        zoomControl: true,
                        styles: mapStyles,
                        /*restriction: {
                            latLngBounds: bounds,
                            strictBounds: false,
                        },*/
                    });

                    fitBounds();

                    google.maps.event.addDomListener(window, 'resize', function () {
                        fitBounds();
                    });

                    const mapMarkers = mapContainer.querySelectorAll('[data-action="marker"]');

                    Array.from(mapMarkers).forEach(mapMarker => {
                        const markerLat = parseFloat(mapMarker.getAttribute('data-lat'));
                        const markerLng = parseFloat(mapMarker.getAttribute('data-lng'));
                        const markerIcon = mapMarker.getAttribute('data-icon');
                        const markerPosition = new google.maps.LatLng(markerLat, markerLng);

                        if (!isNaN(markerLat) && !isNaN(markerLng)) {
                            const marker = new google.maps.Marker({
                                position: markerPosition,
                                map: map,
                                icon: markerIcon
                            });
                        }
                    });

                    /*let center = {
                        lat: 56.239615,
                        lng: 6.892873
                    };

                    if (mapContainer.getAttribute('data-map-center') != '') {
                        const customCenter = mapContainer.getAttribute('data-map-center').replace('(','').replace(')','').split(',');
                        center.lat = parseFloat(customCenter[0]);
                        center.lng = parseFloat(customCenter[1]);
                        multiPins = true;
                        multiBounds = new google.maps.LatLngBounds()
                    }

                    multiPins = true;
                    multiBounds = new google.maps.LatLngBounds();

                    const mapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":"0"},{"weight":1.2},{"gamma":"1"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f4f3f2"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"},{"weight":"1"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f4f3f2"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#f4f3f2"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"weight":0.2},{"gamma":"1"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"saturation":"0"},{"gamma":"1"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e0dcda"},{"lightness":"0"},{"gamma":"1"}]},{"featureType": "water","elementType": "labels","stylers": [{"visibility": "off"}]}];
                    map = new google.maps.Map(mapElm, {
                        zoom: zoomLevel,
                        mapTypeId: 'roadmap',
                        disableDefaultUI: true,
                        draggable: true,
                        scrollwheel: false,
                        zoomControl: true,
                        styles: mapStyles
                    });

                    const mapMarkers = mapContainer.querySelectorAll('[data-action="marker"]');

                    Array.from(mapMarkers).forEach(mapMarker => {
                        const markerLat = parseFloat(mapMarker.getAttribute('data-lat'));
                        const markerLng = parseFloat(mapMarker.getAttribute('data-lng'));
                        const markerIcon = mapMarker.getAttribute('data-icon');

                        if (!isNaN(markerLat) && !isNaN(markerLng)) {
                            const marker = new google.maps.Marker({
                                position: {lat: markerLat, lng: markerLng},
                                map: map,
                                icon: markerIcon
                            });

                            if (multiPins) {
                                multiBounds.extend(marker.position);
                            }
                        }
                    });

                    if (multiBounds) {
                        fitBounds();
                    } else {
                        map.setCenter(center);
                    }

                    google.maps.event.addDomListener(window, 'resize', function () {
                        fitBounds();
                    });*/
                }
            }
        });
    }
}